document.addEventListener('DOMContentLoaded', function () {
  const form = document.getElementById('trade-application-form');

  if (!form) {
    return;
  }

  /*
   * Easy Garden Trade Applications API
   */
  const API_URL =
    'https://script.google.com/macros/s/AKfycbwMmLj8TFJGrWdDfZJZTNf7msUXhTKNNhrgm3hpGcesuIlVgARr4ZpNP6KOd5l0HAwhug/exec';

  const submitButton = document.getElementById('trade-submit-button');
  const formMessage = document.getElementById('trade-form-message');
  const successPanel = document.getElementById(
    'trade-application-success'
  );
  const referenceElement = document.getElementById(
    'trade-application-reference'
  );
  const loadingOverlay = document.getElementById(
    'trade-loading-overlay'
  );

  form.addEventListener('submit', async function (event) {
    event.preventDefault();

    clearErrors();

    const payload = buildPayload();

    if (!validateForm(payload)) {
      showFormMessage(
        'Please check the highlighted fields and try again.',
        'error'
      );

      const firstInvalidField = form.querySelector(
        '[aria-invalid="true"]'
      );

      if (firstInvalidField) {
        firstInvalidField.focus();
      }

      return;
    }

    setSubmitting(true);

    try {
      const response = await fetch(API_URL, {
        method: 'POST',
        /*
         * text/plain avoids an unnecessary browser preflight request
         * while Apps Script still receives valid JSON.
         */
        headers: {
          'Content-Type': 'text/plain;charset=utf-8'
        },
        body: JSON.stringify(payload),
        redirect: 'follow'
      });

      const responseText = await response.text();

      let result;

      try {
        result = JSON.parse(responseText);
      } catch (parseError) {
        throw new Error(
          'The server returned an unexpected response.'
        );
      }

      if (!result.success) {
        handleApiError(result);
        return;
      }

      form.hidden = true;

      if (referenceElement) {
        referenceElement.textContent =
          result.application_id || '';
      }

      if (successPanel) {
        successPanel.hidden = false;
        successPanel.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    } catch (error) {
      console.error('Trade application submission failed:', error);

      showFormMessage(
        'We could not submit your application. Please check your connection and try again.',
        'error'
      );
    } finally {
      setSubmitting(false);
    }
  });

  function buildPayload() {
    const formData = new FormData(form);

    return {
      application_type:
        formData.get('application_type') || '',

      organisation_name:
        formData.get('organisation_name') || '',

      trading_name:
        formData.get('trading_name') || '',

      website:
        formData.get('website') || '',

      vat_number:
        formData.get('vat_number') || '',

      cro_number:
        formData.get('cro_number') || '',

      charity_number:
        formData.get('charity_number') || '',

      years_trading:
        formData.get('years_trading') || '',

      contact_first_name:
        formData.get('contact_first_name') || '',

      contact_last_name:
        formData.get('contact_last_name') || '',

      contact_position:
        formData.get('contact_position') || '',

      phone:
        formData.get('phone') || '',

      email:
        formData.get('email') || '',

      address_line_1:
        formData.get('address_line_1') || '',

      address_line_2:
        formData.get('address_line_2') || '',

      town_city:
        formData.get('town_city') || '',

      county:
        formData.get('county') || '',

      eircode:
        formData.get('eircode') || '',

      estimated_annual_spend:
        formData.get('estimated_annual_spend') || '',

      product_interests:
        formData.getAll('product_interests'),

      business_description:
        formData.get('business_description') || '',

      existing_customer:
        formData.get('existing_customer') === 'true',

      existing_loyalty_number:
        formData.get('existing_loyalty_number') || '',

      terms_accepted:
        formData.get('terms_accepted') === 'true'
    };
  }

  function validateForm(payload) {
    let valid = true;

    if (!payload.application_type) {
      setFieldError(
        'application_type',
        'Please select the type of account.'
      );
      valid = false;
    }

    if (!payload.organisation_name.trim()) {
      setFieldError(
        'organisation_name',
        'Please enter the business or organisation name.'
      );
      valid = false;
    }

    if (!payload.contact_first_name.trim()) {
      setFieldError(
        'contact_first_name',
        'Please enter the contact first name.'
      );
      valid = false;
    }

    if (!payload.contact_last_name.trim()) {
      setFieldError(
        'contact_last_name',
        'Please enter the contact surname.'
      );
      valid = false;
    }

    if (!payload.phone.trim()) {
      setFieldError(
        'phone',
        'Please enter a telephone or mobile number.'
      );
      valid = false;
    }

    if (!payload.email.trim()) {
      setFieldError(
        'email',
        'Please enter an email address.'
      );
      valid = false;
    } else if (!isValidEmail(payload.email)) {
      setFieldError(
        'email',
        'Please enter a valid email address.'
      );
      valid = false;
    }

    if (!payload.address_line_1.trim()) {
      setFieldError(
        'address_line_1',
        'Please enter the first line of the address.'
      );
      valid = false;
    }

    if (!payload.town_city.trim()) {
      setFieldError(
        'town_city',
        'Please enter the town or city.'
      );
      valid = false;
    }

    if (!payload.county) {
      setFieldError(
        'county',
        'Please select a county.'
      );
      valid = false;
    }

    if (!payload.estimated_annual_spend) {
      setFieldError(
        'estimated_annual_spend',
        'Please select an estimated annual spend.'
      );
      valid = false;
    }

    if (payload.business_description.trim().length < 20) {
      setFieldError(
        'business_description',
        'Please provide a little more information about your business or organisation.'
      );
      valid = false;
    }

    if (!payload.terms_accepted) {
      setFieldError(
        'terms_accepted',
        'You must confirm the declaration before submitting.'
      );
      valid = false;
    }

    return valid;
  }

  function handleApiError(result) {
    if (
      result.code === 'VALIDATION_ERROR' &&
      result.field_errors
    ) {
      Object.keys(result.field_errors).forEach(function (fieldName) {
        setFieldError(
          fieldName,
          result.field_errors[fieldName]
        );
      });
    }

    showFormMessage(
      result.message ||
        'Your application could not be submitted. Please check your details and try again.',
      'error'
    );
  }

  function setFieldError(fieldName, message) {
    const errorElement = form.querySelector(
      '[data-error-for="' + fieldName + '"]'
    );

    if (errorElement) {
      errorElement.textContent = message;
    }

    const fields = form.querySelectorAll(
      '[name="' + fieldName + '"]'
    );

    fields.forEach(function (field) {
      field.setAttribute('aria-invalid', 'true');
    });
  }

  function clearErrors() {
    form.querySelectorAll('.trade-field-error').forEach(
      function (errorElement) {
        errorElement.textContent = '';
      }
    );

    form.querySelectorAll('[aria-invalid="true"]').forEach(
      function (field) {
        field.removeAttribute('aria-invalid');
      }
    );

    showFormMessage('', '');
  }

  function showFormMessage(message, type) {
    if (!formMessage) {
      return;
    }

    formMessage.textContent = message;
    formMessage.className = 'trade-form-message';

    if (type) {
      formMessage.classList.add(
        'trade-form-message--' + type
      );
    }

    formMessage.hidden = !message;
  }

  function setSubmitting(isSubmitting) {
    if (submitButton) {
      submitButton.disabled = isSubmitting;
      submitButton.textContent = isSubmitting
        ? 'Submitting application…'
        : 'Submit application';
    }

    if (loadingOverlay) {
      loadingOverlay.hidden = !isSubmitting;
    }
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i.test(
      email.trim()
    );
  }
});